import {
  prepareEntityShare,
  prepareEntityCreateShare,
  updateEntityShare,
  loadUserSharesPaginated
} from "api/entity-share";
import notifyingAction from "../notifyingAction";
const prepare = notifyingAction({
  action: (_entityType, _entityTitle, entityGRN, payload) => prepareEntityShare(entityGRN, payload),
  error: (error, entityType, entityName) => ({
    message: `Preparing shares for ${entityType} "${entityName}" failed with status: ${error}`
  })
});
const prepareCreate = notifyingAction({
  action: (_entityType, _entityTitle, payload) => prepareEntityCreateShare(payload),
  error: (error, entityType, entityName) => ({
    message: `Preparing shares for ${entityType} "${entityName}" failed with status: ${error}`
  })
});
const update = notifyingAction({
  action: (_entityType, _entityTitle, entityGRN, payload) => updateEntityShare(entityGRN, payload),
  error: (error, entityType, entityName) => ({
    message: `Updating shares for ${entityType} "${entityName}" failed with status: ${error}`
  }),
  success: (entityType, entityName) => ({
    message: `Shares for ${entityType} "${entityName}" updated successfully`
  })
});
const loadUserSharesPaginatedAction = notifyingAction({
  action: (userId, pagination) => loadUserSharesPaginated(userId, pagination),
  error: (error, userId) => ({
    message: `Loading entities which got shared for user with id "${userId}" failed with status: ${error}`
  })
});
export default {
  prepare,
  prepareCreate,
  update,
  loadUserSharesPaginated: loadUserSharesPaginatedAction
};
